<script>
import utils from '../utils'

function hasChild(root) {
  return root && root.MenuInfos && root.MenuInfos.length;
}

function createChildVNodes(h, root) {
  const vnodes = [];
  if (!hasChild(root))
    return vnodes;
  utils.each(root.MenuInfos, m=>{
    if (hasChild(m)) {
      const childVNodes = createChildVNodes(h, m);
      const vnode = h(
        'el-submenu',
        {
          props: {
            index: m.MenuId
          }
        },
        [
          h(
            'template',
            { slot: "title" },
            [
              h('i', { class: 'el-icon-location' }),
              h('span', [ m.MenuName ])
            ]
          )
        ].concat(childVNodes)
      );
      vnodes.push(vnode);
    }
    else {
      const vnode = h(
        'el-menu-item',
        {
          props: { index: m.MenuId }
        },
        [
          h(
            'template',
            { slot: "title" },
            [
              h('i', { class: 'el-icon-setting' }),
              h('span', [ m.MenuName ])
            ]
          )
        ]
      );
      vnodes.push(vnode);
    }
  });
  return vnodes;
}

export default {
  name: 'ZjSideMenu',
  computed: {
    currentNavMenu() {
      return this.menu.currentNavMenu;
    },
    currentMenu() {
      return this.menu.currentMenu;
    }
  },
  render: function (h) {
    const r = h(
      'div',
      {
        class: 'zj-sidemenu'
      },
      [
        h(
          'el-menu',
          {
            class: 'zj-sidemenu-elmenu',
            props: {
              'background-color': '',
              'text-color': '',
              'active-text-color': '',
              'default-active': (this.currentMenu ? this.currentMenu.MenuId : '')
            },
            on: {
              select: this.handleSelect,
              open: this.handleOpen,
              close: this.handleClose
            }
          },
          createChildVNodes(h, this.currentNavMenu)
        )
      ]
    );
    return r;
  },
  methods: {
    handleSelect(key) {
      this.dispatch('ZjApp', 'sidemenu-select', [key]);
    },
    handleOpen(key) {
      this.dispatch('ZjApp', 'sidemenu-open', [key]);
    },
    handleClose(key) {
      this.dispatch('ZjApp', 'sidemenu-close', [key]);
    }
  }
}
</script>
